const threeChannelContactPage = [
    {
        selector: '[data-three-channel-contact-form]',
        path: { filename: 'threeChannelContactPage' },
    },
];

export { threeChannelContactPage };
